import React, { useEffect } from "react";
import { cero_item } from "../../json/protocolocero";
import { sesiones_item } from "../../json/protocolocero";
import { Link } from 'react-router-dom';
import "./protocolocero.css";

const ProtocoloCero = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
 const linkStyle = {
    textDecoration: 'none'
  };
  return (
    <div className="container protocolocero-container">
      <div className='row'>
            <div className='col_12'>
                <div className='protocolocero_title'>
                  <h1>PROTOCOLO CERO</h1>
                     <hr class="blue small-margin"></hr>
                       <div class="row row-gob row-body">
                                <div class="row-content">
                       <header class="col-12">
                                    {/* <h3 class="h3-apps">Protocolo de Cero Tolerancia a las conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral del poder ejecutivo y pronunciamiento del titular de la SADERH</h3> */}
                                    <hr class="blue small-margin"></hr>
                                  </header>
                                   <div className="row">
                                    <iframe
                                    src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2026/DocsPagweb/ProtocoloCero.pdf"
                                    height="1000"
                                     width="1110"
                                     />
                                     <hr class="blue small-margin"></hr>
                                     <div class="row row-gob row-body">
                                                    <div class="row-content">
                                           <header class="col-12">
                                                        <h3 class="h3-apps">Sesiones Ordinarias</h3>
                                                        <hr class="blue small-margin"></hr>
                                                      </header>
                                                       <div className="row">
                                             {sesiones_item.map((item, index) => (
                                               <>
                                                 <div key={index} className="col-md-4">
                                                   <Link  style={linkStyle} to={item.etica_item_url}>
                                                     <div className="card">
                                                       <div className="card-body">
                                                         <div className="sec_transparencia">
                                                           <h5>{item.etica_item_nombre}</h5>
                                                         </div>
                                                       </div>
                                                     </div>
                                                   </Link>
                                                 </div>
                                               </>
                                             ))}
                                           </div>
                                           </div>
                                           </div>
                         {/* {cero_item.map((item, index) => (
                           <>
                             <div key={index} className="col-md-4">
                               <Link  style={linkStyle} to={item.cero_item_url}>
                                 <div className="card">
                                   <div className="card-body">
                                     <div className="sec_transparencia">
                                       <h5>{item.cero_item_nombre}</h5>
                                     </div>
                                   </div>
                                 </div>
                               </Link>
                             </div>
                           </>
                         ))} */}
                       </div>
                       </div>
                       </div>
                </div>
            </div>
        </div>

      
      <hr className="hr-gob" />
    </div>
  );
};

export default ProtocoloCero;
